import React  from "react";
import { useSelector , useDispatch } from 'react-redux';


import { useListmails   } from "../../state/reactquery";
import {  useUser } from "../../state/reactquery";
import { defineTypeMail} from "../../state/redux";
import { modifyDisplaymodal } from "../../state/redux";

import ButtonImgLeft from "../Buttons/ButtonImgLeft";
import ListMails from "./ListMails";

import './ClientMail.scss';



function ClientMail( ) {
  const dispatch = useDispatch() ;
  const {data: user} = useUser(localStorage.getItem('token'))  ;
  const leadactu  = useSelector(state=>state.lead.leadactu);
  const {data: messages} = useListmails(user?.postmail,leadactu?.email) ; 



  return (<div className='divemails' >
            <div className='emailing' >
              <ListMails  messages={messages}  />
             
              <div className="divmessagesfooter">
                    <ButtonImgLeft texte={messages?.length >0 ?"Répondre":"Ecrire un message"}  
                                    color='bouton_color_orange' 
                                    size='bouton_size_normal' 
                                    image='imagemail' 
                                    onclick={()=>{ dispatch(defineTypeMail('ficheclient'));
                                        dispatch(modifyDisplaymodal('mod_mailingmodal')) ; 

                           }}   /> 
                
              </div>  </div>      
          </div>);
}

export default ClientMail;